import { defineField } from 'sanity';

export const localizedText = defineField({
    name: 'localizedText',
    title: 'Localized Text',
    type: 'object',
    fields: [
        {
            name: 'en',
            title: 'English',
            type: 'text',
        },
        {
            name: 'sr',
            title: 'Serbian',
            type: 'text',
        },
    ],
});
